import { jsx as o, jsxs as b, Fragment as j } from "react/jsx-runtime";
import { twMerge as r } from "tailwind-merge";
import { TooltipCustomButton as z, TooltipCustomDiv as C } from "./custom-button.mjs";
import { Popover as E, PopoverButton as L, Transition as O, PopoverPanel as R } from "@headlessui/react";
import { useRef as d, Fragment as B } from "react";
import { useIsOverflowText as D } from "../../hooks/use-is-overflow-text.mjs";
import { useWindowSize as H } from "../../hooks/use-window-size.mjs";
import { useFloatHover as I } from "../../hooks/use-float-hover.mjs";
const Q = ({
  mode: e = "hover",
  popoverButtonRef: a,
  label: h,
  position: w = "top",
  anchor: x,
  className: y,
  wrapperClassName: g,
  popoverClassName: T,
  labelClassName: F,
  disabled: t,
  stayOnHover: s,
  children: n,
  hoverOpenDelay: k,
  afterLeave: M
}) => {
  const i = d(null), N = d(null), l = D(i), { width: P } = H(), { show: c, delayOpen: u, delayClose: f } = I({ hoverOpenDelay: k });
  return /* @__PURE__ */ o(E, { className: r("flex items-center", g), children: ({ open: p }) => {
    const m = t ? !1 : P < 1024 ? e === "overflow" && !l ? !1 : p : e === "click" ? p : e === "hover" || e === "overflow" && l ? c : !1;
    return /* @__PURE__ */ b(j, { children: [
      /* @__PURE__ */ o(
        L,
        {
          ref: (v) => {
            i && (i.current = v), a && (a.current = v);
          },
          as: e === "click" ? z : C,
          className: r(
            "relative truncate outline-hidden",
            e === "click" && !t && "cursor-pointer",
            "h-full w-full max-w-fit",
            y
          ),
          disabled: t,
          onMouseEnter: u,
          onMouseLeave: f,
          children: typeof n == "function" ? n(m) : n
        }
      ),
      /* @__PURE__ */ o(
        O,
        {
          as: B,
          afterLeave: M,
          show: m,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ o(
            R,
            {
              ref: N,
              anchor: x ?? w.replace("-", " "),
              className: r(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                T
              ),
              onMouseEnter: s ? u : void 0,
              onMouseLeave: s ? f : void 0,
              children: /* @__PURE__ */ o(
                "div",
                {
                  className: r(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    F
                  ),
                  children: h
                }
              )
            }
          )
        }
      )
    ] });
  } });
};
export {
  Q as Tooltip
};
